// extracted by mini-css-extract-plugin
module.exports = {"container":"_2_B57","thumbnails":"aiRaU","arrow":"_3YVSG","left":"_2UGgY","right":"_2RjR9"};